import _ from 'underscore';

import { StringHelper } from '@biteinc/helpers';

app.CompoundModGroupModsView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} compound-mod-group-mods-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {
          _id: StringHelper.randomHexString(24),
        };
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        let title;
        const fields = fieldGroupView.getValue();
        if (_.has(fields, 'name')) {
          title = fields.name;
        }
        return title || '';
      },
      setSetValueHandlers(fieldView, handler) {
        fieldView.fieldViewsByField.name.$form.keyup(handler);
      },
      templateData: {
        title: 'Mods',
        buttonText: 'New mods',
        emptyText: 'No mods yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
